import React from 'react';

function GoogleFlights({ flights, isLoading }) {
  if (isLoading) {
    return (
      <div style={{
        padding: '20px',
        margin: '20px 0',
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
        textAlign: 'center'
      }}>
        <p>Loading Google Flights results...</p>
      </div>
    );
  }

  if (!flights || flights.length === 0) {
    return null;
  }

  return (
    <div style={{
      margin: '20px 0',
      padding: '20px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <h3 style={{
        margin: '0 0 15px 0',
        fontSize: '1.3em',
        color: '#333'
      }}>
        Google Flights Results
      </h3>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        {flights.map((flight, index) => {
          return (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '15px',
                border: '1px solid #e0e0e0',
                borderRadius: '6px',
                backgroundColor: '#fafafa',
                cursor: 'pointer',
                transition: 'all 0.2s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.borderColor = '#ccc';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#fafafa';
                e.currentTarget.style.borderColor = '#e0e0e0';
              }}
            >
              {/* Airline Logo */}
              <div style={{ marginRight: '15px', minWidth: '40px' }}>
                {flight.airline_logo && (
                  <img
                    src={flight.airline_logo}
                    alt={flight.airline}
                    style={{
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%'
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                )}
              </div>

              {/* Flight Times and Route */}
              <div style={{ flex: 1 }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '8px'
                }}>
                  <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>
                    {flight.departure_time}
                  </span>
                  <span style={{ margin: '0 10px', color: '#666' }}>–</span>
                  <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>
                    {flight.arrival_time}
                  </span>
                </div>
                <div style={{ fontSize: '0.9em', color: '#666' }}>
                  {flight.airline}
                </div>
              </div>

              {/* Duration */}
              <div style={{
                textAlign: 'center',
                padding: '0 20px',
                borderLeft: '1px solid #e0e0e0',
                borderRight: '1px solid #e0e0e0'
              }}>
                <div style={{ fontSize: '0.9em', marginBottom: '4px' }}>
                  {flight.duration}
                </div>
                {flight.segments && flight.segments.length > 0 && (
                  <div style={{ fontSize: '0.85em', color: '#666' }}>
                    {flight.segments[0].departure_airport}–{flight.segments[0].arrival_airport}
                  </div>
                )}
              </div>

              {/* Stops */}
              <div style={{
                textAlign: 'center',
                padding: '0 20px'
              }}>
                <div style={{
                  fontSize: '0.9em',
                  fontWeight: flight.stops === 0 ? 'bold' : 'normal',
                  color: flight.stops === 0 ? '#4CAF50' : '#666'
                }}>
                  {flight.stops === 0 ? 'Nonstop' : `${flight.stops} stop${flight.stops > 1 ? 's' : ''}`}
                </div>
              </div>

              {/* CO2 Emissions */}
              {flight.emissions_kg && (
                <div style={{
                  textAlign: 'center',
                  padding: '0 20px',
                  borderLeft: '1px solid #e0e0e0'
                }}>
                  <div style={{ fontSize: '0.9em' }}>
                    {flight.emissions_kg} kg CO2e
                  </div>
                  {flight.emissions_info && (
                    <div style={{
                      fontSize: '0.8em',
                      color: flight.emissions_info.includes('-') ? '#4CAF50' : '#f44336'
                    }}>
                      {flight.emissions_info}
                    </div>
                  )}
                </div>
              )}

              {/* Price */}
              <div style={{
                marginLeft: '20px',
                textAlign: 'right',
                minWidth: '100px'
              }}>
                <div style={{
                  fontSize: '1.3em',
                  fontWeight: 'bold',
                  color: '#333'
                }}>
                  {flight.price_currency === 'EUR' ? '€' : '$'}{flight.price}
                </div>
                <div style={{
                  fontSize: '0.85em',
                  color: '#666'
                }}>
                  {flight.is_round_trip ? 'round trip' : 'one way'}
                </div>
              </div>

              {/* Expand Icon */}
              <div style={{
                marginLeft: '10px',
                color: '#999'
              }}>
                ▼
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default GoogleFlights;
